// React and routing imports
import React from "react";
import { Route, Routes } from "react-router-dom";

// Layout and page components
import UserLayout from "../layouts/UserLayout";
import Home from "../pages/Public/Home/Home";
import SubscriptionDetails from "../pages/Public/SubscriptionDetails/SubscriptionDetails";
import Profile from "../pages/Public/Profile/Profile";
import OnboardingQuestions from "../pages/Public/OnboardingQuestions/OnboardingQuestions";

// Routes accessible only to authenticated users
const AuthenticatePublicRoutes = () => {
  return (
    <Routes>
      {/* Main layout wrapper */}
      <Route path="/" element={<UserLayout />}>
        {/* Home page */}
        <Route path="/" element={<Home />} />
        {/* User subscription management */}
        <Route path="/subscription-details" element={<SubscriptionDetails />} />
        {/* Profile routes - with and without section parameter */}
        <Route path="/profile/:section" element={<Profile />} />
        <Route path="/profile" element={<Profile/>} />
        {/* User onboarding flow */}
        <Route path="/onboarding-questions" element={<OnboardingQuestions />} />
      </Route>
    </Routes>
  );
};

export default AuthenticatePublicRoutes;
